import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCatalog, placeholderImg } from "../shared";
import bannerVideo from "../../assets/bliss-anim-ig-med.mp4";
import { Canvas } from "@react-three/fiber";
import RingScene from "./RingScene";
import * as THREE from "three";

/** Catalog grid — pulls from rings API */
function HomeGrid() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError("");
    fetchCatalog({ limit: 24 })
      .then((data) => {
        if (mounted) setItems(data.items || []);
      })
      .catch((e) => {
        if (mounted) setError(String(e.message || e));
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="jh-section">
      {/* <div id="scroll-section" style={{ top: 0, height: "50vh" }}>
        <Canvas
          shadows
          dpr={[1, 2]}
          gl={{ antialias: true, physicallyCorrectLights: true }}
          onCreated={({ gl }) => {
            gl.outputColorSpace = THREE.SRGBColorSpace;
            gl.toneMapping = THREE.ACESFilmicToneMapping;
            gl.toneMappingExposure = 1.35;
            gl.shadowMap.enabled = true;
            gl.shadowMap.type = THREE.PCFSoftShadowMap;
          }}
          camera={{ position: [0, 0, 2.5], fov: 45 }}
        >
          <ambientLight intensity={0.12} />
          <directionalLight
            castShadow
            intensity={2.2}
            position={[3, 4, 4]}
            shadow-mapSize={[2048, 2048]}
            shadow-camera-near={0.1}
            shadow-camera-far={20}
            shadow-camera-left={-5}
            shadow-camera-right={5}
            shadow-camera-top={5}
            shadow-camera-bottom={-5}
          />
          <directionalLight intensity={0.9} position={[-4, 2, 3]} />
          <directionalLight intensity={1.1} position={[-2, 3, -4]} />

          <mesh rotation-x={-Math.PI / 2} position={[0, -1, 0]} receiveShadow>
            <planeGeometry args={[20, 20]} />
            <shadowMaterial transparent opacity={0.22} />
          </mesh>
          <RingScene modelUrl="/models/crimson-flame.glb" />
        </Canvas>
      </div> */}
      <div className="jh-banner">
        <video
          className="jh-banner-video"
          src={bannerVideo}
          autoPlay
          muted
          playsInline
          preload="metadata"
        />
      </div>

      <div className="jh-container">
        <div className="jh-section-head">
          <h1 className="jh-title">New Designs</h1>
        </div>

        {loading && <div className="jh-sub">Loading...</div>}
        {error && (
          <div className="jh-sub" style={{ color: "#b91c1c" }}>
            Error: {error}
          </div>
        )}

        <ul className="jh-grid">
          {items.map((p) => (
            <li key={p._id}>
              <Link
                to={`/product/${encodeURIComponent(p._id)}`}
                className="jh-card"
              >
                <div className="jh-image-wrap">
                  <img
                    className="jh-image"
                    src={
                      p.metalImages?.[p.defaultOptions?.metal_type]?.[0] ||
                      p.image ||
                      placeholderImg
                    }
                    alt={p.title}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.src = placeholderImg;
                    }}
                  />
                </div>
                <div className="jh-card-body">
                  <h2 className="jh-name">{p.title}</h2>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default HomeGrid;
